module.exports = __webpack_public_path__ + "c41581fa2cb0403fd585dfd6d9440e7e.jpg";